import { render } from "./CreateRolePage.vue?vue&type=template&id=2efffb02&ts=true"
import script from "./CreateRolePage.vue?vue&type=script&lang=ts"
export * from "./CreateRolePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/System/Roles/CreateRolePage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2efffb02"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2efffb02', __exports__)) {
    api.reload('2efffb02', __exports__)
  }
  
  module.hot.accept("./CreateRolePage.vue?vue&type=template&id=2efffb02&ts=true", () => {
    api.rerender('2efffb02', render)
  })

}


export default __exports__